export default {
  record_video_label: 'Gravar Video',
  upload_video_label: 'Selecionar Video',
  submit: 'Submeter',
  upload_in_progess: 'Aguarde enquanto seu vídeo é carregado. Isso pode levar alguns minutos.',
  error_alert_title: 'Erro de Upload',
  retry_button_label: 'Tentar Novamente',
  start_recording_label: 'Gravar',
  stop_recording_label: 'Parar de Gravar',
  cancel_label: 'Cancelar'
};



// WEBPACK FOOTER //
// ./src/translations/pt-BR.js